import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "produse-view" }
const _hoisted_2 = { class: "tab-label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  style: {"width":"44px","height":"44px","border-radius":"50%","background":"#f1f5f9","border":"2px solid #e2e8f0","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_7 = { class: "popup-body-modern sel-popup-body" }
const _hoisted_8 = { class: "sel-layout" }
const _hoisted_9 = { class: "sel-left" }
const _hoisted_10 = { class: "sel-panel-header" }
const _hoisted_11 = {
  key: 0,
  class: "sel-badge"
}
const _hoisted_12 = { class: "sel-list" }
const _hoisted_13 = {
  key: 0,
  class: "sel-empty"
}
const _hoisted_14 = {
  key: 1,
  class: "sel-empty"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "sel-item-text" }
const _hoisted_17 = { class: "sel-right" }
const _hoisted_18 = { class: "sel-panel-header" }
const _hoisted_19 = {
  key: 0,
  class: "sel-badge"
}
const _hoisted_20 = { class: "sel-list" }
const _hoisted_21 = {
  key: 0,
  class: "sel-empty sel-empty--hint"
}
const _hoisted_22 = {
  key: 1,
  class: "sel-empty"
}
const _hoisted_23 = {
  key: 2,
  class: "sel-empty"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "sel-cat-cod" }
const _hoisted_26 = { class: "sel-cat-nume" }
const _hoisted_27 = { class: "sel-footer" }
const _hoisted_28 = { class: "sel-selection-info" }
const _hoisted_29 = {
  key: 1,
  style: {"color":"#94a3b8","font-size":"13px"}
}
const _hoisted_30 = { style: {"display":"flex","gap":"8px"} }
const _hoisted_31 = { class: "popup-body-modern" }
const _hoisted_32 = { class: "jurnal-popup-body" }
const _hoisted_33 = { class: "jp-field jp-switch-row" }
const _hoisted_34 = { class: "jp-field" }
const _hoisted_35 = { class: "jp-field" }
const _hoisted_36 = { class: "jp-field" }
const _hoisted_37 = { class: "jp-field" }
const _hoisted_38 = { class: "jp-field" }
const _hoisted_39 = { class: "jp-field jp-switch-row" }
const _hoisted_40 = { class: "jp-field jp-switch-row" }
const _hoisted_41 = { class: "jp-curent-box" }
const _hoisted_42 = { class: "jp-curent-inner" }
const _hoisted_43 = { class: "jp-curent-value" }
const _hoisted_44 = { class: "jp-exemplu" }
const _hoisted_45 = { class: "jp-exemplu-value" }
const _hoisted_46 = { class: "jp-footer" }
const _hoisted_47 = { class: "popup-body-modern" }
const _hoisted_48 = { class: "add-popup-grid" }
const _hoisted_49 = { class: "produs-card produs-card-full" }
const _hoisted_50 = { class: "pcard-body" }
const _hoisted_51 = { class: "pfields-row" }
const _hoisted_52 = { class: "pfield" }
const _hoisted_53 = { class: "pfield pfield-wide" }
const _hoisted_54 = { class: "pfield" }
const _hoisted_55 = { class: "pfield" }
const _hoisted_56 = { class: "pfield" }
const _hoisted_57 = { class: "pfields-switches" }
const _hoisted_58 = { class: "pfield-switch" }
const _hoisted_59 = { class: "pfield-switch" }
const _hoisted_60 = { class: "pfield-switch" }
const _hoisted_61 = { class: "pfield-switch" }
const _hoisted_62 = { class: "produs-card" }
const _hoisted_63 = { class: "pcard-body" }
const _hoisted_64 = { class: "pfields-row" }
const _hoisted_65 = { class: "pfield" }
const _hoisted_66 = { class: "pfield" }
const _hoisted_67 = { class: "pfield" }
const _hoisted_68 = { class: "pfield" }
const _hoisted_69 = { class: "pfield" }
const _hoisted_70 = { class: "pfield" }
const _hoisted_71 = { class: "pfield" }
const _hoisted_72 = { class: "pfield" }
const _hoisted_73 = { class: "pfields-switches" }
const _hoisted_74 = { class: "pfield-switch" }
const _hoisted_75 = { class: "produs-card" }
const _hoisted_76 = { class: "pcard-body" }
const _hoisted_77 = { class: "pfields-row" }
const _hoisted_78 = { class: "pfield" }
const _hoisted_79 = { class: "pfield" }
const _hoisted_80 = { class: "pfield" }
const _hoisted_81 = { class: "pfield" }
const _hoisted_82 = { class: "pfield" }
const _hoisted_83 = { class: "pfield" }
const _hoisted_84 = { class: "pfield" }
const _hoisted_85 = { class: "pfield" }
const _hoisted_86 = { class: "pfield" }
const _hoisted_87 = { class: "produs-card" }
const _hoisted_88 = { class: "pcard-body" }
const _hoisted_89 = { class: "pfields-row" }
const _hoisted_90 = { class: "pfield" }
const _hoisted_91 = { class: "pfield" }
const _hoisted_92 = { class: "pfield" }
const _hoisted_93 = { class: "pfield pfield-wide" }
const _hoisted_94 = { class: "pfield" }
const _hoisted_95 = { class: "produs-card" }
const _hoisted_96 = { class: "pcard-body" }
const _hoisted_97 = { class: "pfields-row" }
const _hoisted_98 = { class: "pfield" }
const _hoisted_99 = { class: "pfield" }
const _hoisted_100 = { class: "pfield" }
const _hoisted_101 = { class: "pfield" }
const _hoisted_102 = { class: "pfield" }
const _hoisted_103 = { class: "pfield pfield-wide" }
const _hoisted_104 = {
  class: "add-imagine-section",
  style: {"margin-top":"12px","padding-top":"12px","border-top":"1px solid #f1f5f9"}
}
const _hoisted_105 = { class: "add-imagine-row" }
const _hoisted_106 = {
  key: 0,
  class: "add-imagine-preview"
}
const _hoisted_107 = ["src"]
const _hoisted_108 = {
  key: 1,
  class: "imagine-placeholder",
  style: {"width":"80px","height":"60px","font-size":"11px"}
}
const _hoisted_109 = { style: {"display":"flex","flex-direction":"column","gap":"6px"} }
const _hoisted_110 = { class: "imagine-upload-btn" }
const _hoisted_111 = { class: "produs-card produs-card-full" }
const _hoisted_112 = { class: "pcard-body" }
const _hoisted_113 = { class: "pfields-row" }
const _hoisted_114 = { class: "pfield" }
const _hoisted_115 = { class: "pfield" }
const _hoisted_116 = { class: "pfield" }
const _hoisted_117 = { class: "pfield" }
const _hoisted_118 = { class: "pfield pfield-wide" }
const _hoisted_119 = { class: "pfield pfield-wide" }
const _hoisted_120 = { class: "pfields-switches" }
const _hoisted_121 = { class: "pfield-switch" }
const _hoisted_122 = { class: "pfield-switch" }
const _hoisted_123 = { class: "add-product-footer" }
const _hoisted_124 = {
  key: 0,
  class: "tab-content produs-tab-content"
}
const _hoisted_125 = { class: "produs-header" }
const _hoisted_126 = { class: "produs-header-left" }
const _hoisted_127 = { class: "produs-header-name" }
const _hoisted_128 = { class: "produs-header-chips" }
const _hoisted_129 = {
  key: 0,
  class: "pchip pchip-code"
}
const _hoisted_130 = {
  key: 1,
  class: "pchip pchip-intern"
}
const _hoisted_131 = {
  key: 2,
  class: "pchip pchip-serviciu"
}
const _hoisted_132 = {
  key: 3,
  class: "pchip pchip-stocabil"
}
const _hoisted_133 = { class: "produs-header-actions" }
const _hoisted_134 = { class: "produs-cards-scroll" }
const _hoisted_135 = { class: "produs-cards-grid" }
const _hoisted_136 = { class: "produs-card produs-card-full" }
const _hoisted_137 = { class: "pcard-body" }
const _hoisted_138 = { class: "pfields-row" }
const _hoisted_139 = { class: "pfield" }
const _hoisted_140 = { class: "pfield" }
const _hoisted_141 = { class: "pfield pfield-wide" }
const _hoisted_142 = { class: "pfield" }
const _hoisted_143 = { class: "pfield" }
const _hoisted_144 = { class: "pfield" }
const _hoisted_145 = { class: "pfields-switches" }
const _hoisted_146 = { class: "pfield-switch" }
const _hoisted_147 = { class: "pfield-switch" }
const _hoisted_148 = { class: "pfield-switch" }
const _hoisted_149 = { class: "pfield-switch" }
const _hoisted_150 = { class: "produs-card produs-card-span2" }
const _hoisted_151 = { class: "pcard-body" }
const _hoisted_152 = { class: "pfields-row" }
const _hoisted_153 = { class: "pfield" }
const _hoisted_154 = { class: "pfield" }
const _hoisted_155 = { class: "pfield" }
const _hoisted_156 = { class: "pfield" }
const _hoisted_157 = { class: "pfield" }
const _hoisted_158 = { class: "pfield" }
const _hoisted_159 = { class: "pfield" }
const _hoisted_160 = { class: "pfield" }
const _hoisted_161 = { class: "pfield" }
const _hoisted_162 = { class: "pfield" }
const _hoisted_163 = { class: "pfield" }
const _hoisted_164 = { class: "pfield" }
const _hoisted_165 = { class: "pfield pfield-wide" }
const _hoisted_166 = { class: "pfields-switches" }
const _hoisted_167 = { class: "pfield-switch" }
const _hoisted_168 = { class: "produs-card" }
const _hoisted_169 = { class: "pcard-body" }
const _hoisted_170 = { class: "pfields-col" }
const _hoisted_171 = { class: "pfield" }
const _hoisted_172 = { class: "pfield" }
const _hoisted_173 = { class: "pfield" }
const _hoisted_174 = { class: "produs-card produs-card-full" }
const _hoisted_175 = { class: "pcard-body" }
const _hoisted_176 = { class: "pfields-row" }
const _hoisted_177 = { class: "pfield" }
const _hoisted_178 = { class: "pfield" }
const _hoisted_179 = { class: "pfield" }
const _hoisted_180 = { class: "pfield" }
const _hoisted_181 = { class: "pfield" }
const _hoisted_182 = { class: "pfield" }
const _hoisted_183 = { class: "pfield pfield-wide" }
const _hoisted_184 = { class: "pfield pfield-wide" }
const _hoisted_185 = { class: "pfield pfield-full" }
const _hoisted_186 = { class: "pfield pfield-wide" }
const _hoisted_187 = { class: "imagine-section" }
const _hoisted_188 = { class: "imagine-container" }
const _hoisted_189 = {
  key: 0,
  class: "imagine-preview"
}
const _hoisted_190 = ["src"]
const _hoisted_191 = {
  key: 1,
  class: "imagine-placeholder"
}
const _hoisted_192 = {
  key: 2,
  class: "imagine-actions"
}
const _hoisted_193 = { class: "imagine-upload-btn" }
const _hoisted_194 = ["onChange"]
const _hoisted_195 = { class: "produs-card" }
const _hoisted_196 = { class: "pcard-body" }
const _hoisted_197 = { class: "pfields-row" }
const _hoisted_198 = { class: "pfield" }
const _hoisted_199 = { class: "pfield" }
const _hoisted_200 = { class: "pfield" }
const _hoisted_201 = { class: "pfield" }
const _hoisted_202 = { class: "pfield" }
const _hoisted_203 = { class: "pfield" }
const _hoisted_204 = { class: "pfield" }
const _hoisted_205 = { class: "pfield" }
const _hoisted_206 = { class: "produs-card produs-card-span2" }
const _hoisted_207 = { class: "pcard-body" }
const _hoisted_208 = { class: "pfields-row" }
const _hoisted_209 = { class: "pfield" }
const _hoisted_210 = { class: "pfield" }
const _hoisted_211 = { class: "pfield" }
const _hoisted_212 = { class: "pfield" }
const _hoisted_213 = { class: "pfield" }
const _hoisted_214 = { class: "pfield" }
const _hoisted_215 = { class: "pfield pfield-wide" }
const _hoisted_216 = { class: "pfield" }
const _hoisted_217 = { class: "pfield" }
const _hoisted_218 = { class: "pfields-switches" }
const _hoisted_219 = { class: "pfield-switch" }
const _hoisted_220 = { class: "pfield-switch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxSwitch = _resolveComponent("DxSwitch")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSpeedDialAction = _resolveComponent("DxSpeedDialAction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxTabs, {
      "data-source": _ctx.tabs,
      "selected-index": _ctx.selectedTabIndex,
      "item-template": "tabItem",
      onOptionChanged: _ctx.onTabChanged
    }, {
      tabItem: _withCtx(({ data, index }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(data.text), 1),
          (index > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "tab-close-btn",
                onClick: _withModifiers(($event: any) => (_ctx.closeTab(index)), ["stop"])
              }, "×", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["data-source", "selected-index", "onOptionChanged"]),
    (_ctx.selectedTabIndex === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_DxDataGrid, {
            ref: "dataGrid",
            "data-source": _ctx.dsProduse,
            "key-expr": "Id",
            height: "100%",
            width: "100%",
            "column-auto-width": false,
            "show-column-lines": false,
            "show-row-lines": true,
            "row-alternation-enabled": false,
            "hover-state-enabled": true,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-resizing-mode": "nextColumn",
            onExporting: _ctx.onExporting,
            "on-context-menu-preparing": _ctx.onContextMenuPreparing,
            onRowDblClick: _ctx.onRowDblClick
          }, {
            backBtn: _withCtx(() => [
              _createVNode(_component_DxButton, {
                icon: "back",
                text: "Înapoi la Clase",
                "styling-mode": "outlined",
                onClick: _ctx.goBackToClase
              }, null, 8, ["onClick"])
            ]),
            addProductBtn: _withCtx(() => [
              _createVNode(_component_DxButton, {
                icon: "plus",
                type: "success",
                width: 30,
                height: 30,
                hint: "Adaugă produs nou",
                onClick: _ctx.openAddProduct
              }, null, 8, ["onClick"])
            ]),
            jurnalCodInternBtn: _withCtx(() => [
              _createVNode(_component_DxButton, {
                text: "Jurnal Cod Intern",
                icon: "orderedlist",
                "styling-mode": "outlined",
                onClick: _ctx.openJurnalCodIntern
              }, null, 8, ["onClick"])
            ]),
            thumbTemplate: _withCtx(({ data }) => [
              (data.data.Imagine)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `data:image/jpeg;base64,${data.data.Imagine}`,
                    style: {"width":"44px","height":"44px","object-fit":"cover","border-radius":"50%","border":"2px solid #e2e8f0","display":"block"}
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[61] || (_cache[61] = [
                    _createElementVNode("i", {
                      class: "dx-icon dx-icon-photo",
                      style: {"font-size":"16px","color":"#cbd5e1"}
                    }, null, -1)
                  ]))]))
            ]),
            openBtnTemplate: _withCtx(({ data }) => [
              _createVNode(_component_DxButton, {
                icon: "eyeopen",
                "styling-mode": "outlined",
                hint: "Deschide",
                onClick: ($event: any) => (_ctx.onOpenProduct(data.data))
              }, null, 8, ["onClick"])
            ]),
            activTemplate: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass(data.data.Activ ? 'chip-activ' : 'chip-inactiv')
              }, _toDisplayString(data.data.Activ ? 'Activ' : 'Inactiv'), 3)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxStateStoring, {
                enabled: true,
                type: "localStorage",
                "storage-key": "grid-produse-state-v2"
              }),
              _createVNode(_component_DxColumnChooser, {
                enabled: true,
                title: "Selector coloane",
                "allow-search": true,
                "sort-order": "asc"
              }),
              _createVNode(_component_DxPaging, { "page-size": 20 }),
              _createVNode(_component_DxScrolling, { "column-rendering-mode": "virtual" }),
              _createVNode(_component_DxLoadPanel, { enabled: true }),
              _createVNode(_component_DxExport, {
                enabled: true,
                "allow-export-selected-data": true,
                formats: ['xlsx', 'pdf']
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxGridToolbar, null, {
                default: _withCtx(() => [
                  (_ctx.$route.query.ClasaID)
                    ? (_openBlock(), _createBlock(_component_DxGridToolbarItem, {
                        key: 0,
                        template: "backBtn",
                        location: "before"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DxGridToolbarItem, { template: "addProductBtn" }),
                  _createVNode(_component_DxGridToolbarItem, { name: "columnChooserButton" }),
                  _createVNode(_component_DxGridToolbarItem, { name: "exportButton" }),
                  _createVNode(_component_DxGridToolbarItem, {
                    location: "after",
                    template: "jurnalCodInternBtn"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                width: 62,
                "cell-template": "thumbTemplate",
                fixed: true,
                caption: "",
                "allow-sorting": false,
                "allow-filtering": false
              }),
              _createVNode(_component_DxColumn, {
                width: 55,
                "cell-template": "openBtnTemplate",
                fixed: true,
                "fixed-position": "right",
                caption: "",
                "allow-sorting": false,
                "allow-filtering": false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Cod",
                width: 110,
                fixed: true,
                caption: "Cod Producător"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodIntern",
                width: 120,
                fixed: true
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Nume",
                width: 420,
                fixed: true
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Categorie.Nume",
                caption: "Categorie",
                width: 150
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategorieId",
                visible: false,
                lookup: { dataSource: _ctx.dsCategorie, valueExpr: 'Id', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "Unitate.Nume",
                caption: "UM",
                width: 70
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UnitateId",
                visible: false,
                lookup: { dataSource: _ctx.dsUnitati, valueExpr: 'Id', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "Activ",
                "data-type": "boolean",
                width: 70,
                caption: "Activ",
                "cell-template": "activTemplate"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "NumeComercial",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Descriere",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodBare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Marker",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategorieContabila.Nume",
                caption: "Categorie Contabilă",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategorieContabilaId",
                visible: false,
                lookup: { dataSource: _ctx.dsCategorieContabila, valueExpr: 'Id', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "ClasificatieEconomica.Cod",
                visible: false,
                caption: "Clasificație Economică"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ClasificatieEconomicaId",
                visible: false,
                lookup: { dataSource: _ctx.dsClasificatieEconomica, valueExpr: 'ID', displayExpr: 'Cod' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "TipEtichetaId",
                visible: false,
                caption: "Tip Etichetă"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodD394",
                visible: false,
                lookup: { dataSource: _ctx.dsCoduriD394, valueExpr: 'Nume', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "CategTva",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CategTvaMotivScutire",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodCPV",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodNc8id",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "SursaProdus",
                visible: false,
                caption: "Sursă Produs"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Pret",
                caption: "Preț",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzare",
                caption: "Preț Vânzare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretValuta.Simbol",
                caption: "Preț Valută",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretValutaId",
                visible: false,
                lookup: { dataSource: _ctx.dsPretValuta, valueExpr: 'Id', displayExpr: 'Simbol' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "PretCursBanca.Cod",
                caption: "Preț Curs Bancă",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretCursBancaId",
                visible: false,
                lookup: { dataSource: _ctx.dsBanci, valueExpr: 'ID', displayExpr: 'Cod' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzareData",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "PretVanzareAnterior",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TaxareInversa",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TaxaVamala",
                caption: "Taxă Vamală",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TvaCurent",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TvaCurentData",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "TvaAnterior",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "MasaBuc",
                caption: "Masă Bucată",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "MasaBucNet",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "SeCantareste",
                caption: "Se cântărește",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Stocabil",
                "data-type": "boolean",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "QavertizareStoc",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Qaprovizionare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "LocDepozitare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UnitateAmbalaj.Nume",
                caption: "UM FA",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UnitateAmbalajId",
                visible: false,
                lookup: { dataSource: _ctx.dsUnitati, valueExpr: 'Id', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "CantitatePt1Fa",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Serviciu",
                "data-type": "boolean",
                "set-cell-value": _ctx.serviciuSetCellValue,
                visible: false
              }, null, 8, ["set-cell-value"]),
              _createVNode(_component_DxColumn, {
                "data-field": "Producator",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProducatorTara.Nume",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProducatorTaraId",
                visible: false,
                lookup: { dataSource: _ctx.dsTari, valueExpr: 'ID', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "GarantieLuni",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Url",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Imagine",
                visible: false,
                "cell-template": _ctx.cellTemplateImg
              }, null, 8, ["cell-template"]),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwListat",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwVizibil",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwID",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "WwwSyncedDate",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGID",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGIDBG",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "eMAGIDHU",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPnk",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPNKBG",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "CodPNKHU",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProdusSgr.Nume",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ProdusSgrID",
                visible: false,
                lookup: { dataSource: _ctx.dsProduse, valueExpr: 'Id', displayExpr: 'Nume' }
              }, null, 8, ["lookup"]),
              _createVNode(_component_DxColumn, {
                "data-field": "UserCreare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataCreare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "UserModificare",
                visible: false
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "DataModificare",
                visible: false
              })
            ]),
            _: 1
          }, 8, ["data-source", "onExporting", "on-context-menu-preparing", "onRowDblClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.selectorPopup.visible,
      "show-title": true,
      width: 740,
      height: 520,
      "drag-enabled": true,
      "show-close-button": true,
      "close-on-outside-click": false,
      onHiding: _ctx.onSelectorHide
    }, {
      title: _withCtx(() => [...(_cache[62] || (_cache[62] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-hierarchy" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Selectare Categorie"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Alege clasa și categoria pentru produsul nou")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--config" }, "Pas 1 / 2")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[63] || (_cache[63] = _createElementVNode("i", { class: "dx-icon dx-icon-hierarchy sel-ph-icon" }, null, -1)),
                _cache[64] || (_cache[64] = _createElementVNode("span", { class: "sel-panel-title" }, "Clase", -1)),
                (_ctx.selectorPopup.clasaList.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.selectorPopup.clasaList.length), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_DxTextBox, {
                value: _ctx.selectorPopup.clasaFilter,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectorPopup.clasaFilter) = $event)),
                placeholder: "Caută clasă...",
                "show-clear-button": true,
                "styling-mode": "outlined"
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_12, [
                (!_ctx.selectorPopup.clasaList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Se încarcă..."))
                  : (!_ctx.filteredClase.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Niciun rezultat"))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClase, (clasa) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: clasa.ID,
                    class: _normalizeClass(["sel-item", { 'sel-item--active': _ctx.selectorPopup.selectedClasaId === clasa.ID }]),
                    onClick: ($event: any) => (_ctx.onSelectorClasaClick(clasa.ID))
                  }, [
                    _cache[65] || (_cache[65] = _createElementVNode("i", { class: "dx-icon dx-icon-folder sel-item-icon" }, null, -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(clasa.NumeArborescent), 1)
                  ], 10, _hoisted_15))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[66] || (_cache[66] = _createElementVNode("i", { class: "dx-icon dx-icon-tags sel-ph-icon" }, null, -1)),
                _cache[67] || (_cache[67] = _createElementVNode("span", { class: "sel-panel-title" }, "Categorii", -1)),
                (_ctx.selectorPopup.categoriiForClasa.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.selectorPopup.categoriiForClasa.length), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (!_ctx.selectorPopup.selectedClasaId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[68] || (_cache[68] = [
                      _createElementVNode("i", {
                        class: "dx-icon dx-icon-back",
                        style: {"font-size":"22px","color":"#cbd5e1"}
                      }, null, -1),
                      _createElementVNode("span", null, "Selectează o clasă din stânga", -1)
                    ]))]))
                  : (_ctx.selectorPopup.isLoadingCategorii)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Se încarcă..."))
                    : (!_ctx.selectorPopup.categoriiForClasa.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Nicio categorie pentru această clasă "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.selectorPopup.categoriiForClasa, (cat) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: cat.Id,
                            class: _normalizeClass(["sel-item sel-cat-item", { 'sel-item--active': _ctx.selectorPopup.selectedCategorieId === cat.Id }]),
                            onClick: () => { _ctx.selectorPopup.selectedCategorieId = cat.Id; _ctx.selectorPopup.selectedCategorie = cat; },
                            onDblclick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmSelectorCategorie && _ctx.confirmSelectorCategorie(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(cat.Cod), 1),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(cat.Nume), 1)
                          ], 42, _hoisted_24))
                        }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_ctx.selectorPopup.selectedCategorie)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[69] || (_cache[69] = _createElementVNode("i", {
                      class: "dx-icon dx-icon-check",
                      style: {"color":"#10b981","font-size":"16px"}
                    }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectorPopup.selectedCategorie.Cod) + " — " + _toDisplayString(_ctx.selectorPopup.selectedCategorie.Nume), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, "Selectează o categorie pentru a continua"))
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_DxButton, {
                text: "Continuă",
                type: "success",
                "styling-mode": "contained",
                icon: "arrowright",
                disabled: !_ctx.selectorPopup.selectedCategorieId,
                onClick: _ctx.confirmSelectorCategorie
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _ctx.onSelectorHide
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHiding"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.jurnalPopup.visible,
      "show-title": true,
      title: "Jurnal Cod Intern",
      width: 500,
      height: 650,
      "drag-enabled": true,
      "show-close-button": true,
      "close-on-outside-click": false,
      onHiding: _ctx.onJurnalHide
    }, {
      title: _withCtx(() => [...(_cache[70] || (_cache[70] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-orderedlist" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Jurnal Cod Intern"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Configurare generare coduri interne produse")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--config" }, "Config")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_DxSwitch, {
                value: _ctx.jurnalPopup.editData.Activat,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.jurnalPopup.editData.Activat) = $event))
              }, null, 8, ["value"]),
              _cache[71] || (_cache[71] = _createElementVNode("span", { class: "jp-switch-label" }, "Activ", -1))
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[72] || (_cache[72] = _createElementVNode("label", { class: "jp-label" }, "Număr de cifre:", -1)),
              _createVNode(_component_DxNumberBox, {
                value: _ctx.jurnalPopup.editData.MaximCifre,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.jurnalPopup.editData.MaximCifre) = $event)),
                min: 2,
                max: 9,
                "show-spin-buttons": true,
                width: 90
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[73] || (_cache[73] = _createElementVNode("label", { class: "jp-label" }, "Nr. caractere din codul clasei:", -1)),
              _createVNode(_component_DxNumberBox, {
                value: _ctx.jurnalPopup.editData.NrCaractereClasa,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jurnalPopup.editData.NrCaractereClasa) = $event)),
                min: 0,
                max: 10,
                "show-spin-buttons": true,
                width: 90
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[74] || (_cache[74] = _createElementVNode("label", { class: "jp-label" }, "Nr. caractere din codul grupei:", -1)),
              _createVNode(_component_DxNumberBox, {
                value: _ctx.jurnalPopup.editData.NrCaractere,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.jurnalPopup.editData.NrCaractere) = $event)),
                min: 0,
                max: 10,
                "show-spin-buttons": true,
                width: 90
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[75] || (_cache[75] = _createElementVNode("label", { class: "jp-label" }, "Seria:", -1)),
              _createVNode(_component_DxTextBox, {
                value: _ctx.jurnalPopup.editData.Seria,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.jurnalPopup.editData.Seria) = $event)),
                width: 200
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[76] || (_cache[76] = _createElementVNode("label", { class: "jp-label" }, "Număr inițial:", -1)),
              _createVNode(_component_DxNumberBox, {
                value: _ctx.jurnalPopup.editData.NumarInitial,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.jurnalPopup.editData.NumarInitial) = $event)),
                min: 1,
                "show-spin-buttons": true,
                width: 200
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_DxSwitch, {
                value: _ctx.jurnalPopup.editData.IsCifraControl,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.jurnalPopup.editData.IsCifraControl) = $event))
              }, null, 8, ["value"]),
              _cache[77] || (_cache[77] = _createElementVNode("span", { class: "jp-switch-label" }, "Cu cifră de control", -1))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_DxSwitch, {
                value: _ctx.jurnalPopup.editData.IsDelimitator,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.jurnalPopup.editData.IsDelimitator) = $event)),
                onValueChanged: _ctx.onDelimitatorChanged
              }, null, 8, ["value", "onValueChanged"]),
              _cache[78] || (_cache[78] = _createElementVNode("span", { class: "jp-switch-label" }, "Cu delimitator", -1)),
              _createVNode(_component_DxTextBox, {
                value: _ctx.jurnalPopup.editData.Delimitator,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.jurnalPopup.editData.Delimitator) = $event)),
                disabled: !_ctx.jurnalPopup.editData.IsDelimitator,
                width: 70
              }, null, 8, ["value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _cache[79] || (_cache[79] = _createElementVNode("div", { class: "jp-curent-text" }, "Nr. curent (fără cifra de control):", -1)),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.jurnalPopup.editData.NumarCurent), 1),
                _createVNode(_component_DxButton, {
                  text: "Reset",
                  type: "danger",
                  "styling-mode": "outlined",
                  onClick: _ctx.resetJurnalNumar
                }, null, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[80] || (_cache[80] = _createElementVNode("span", { class: "jp-exemplu-label" }, "Exemplu:", -1)),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.computeJurnalPreview()), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_DxButton, {
                text: "Acceptă",
                type: "success",
                "styling-mode": "contained",
                icon: "check",
                onClick: _ctx.saveJurnalCodIntern
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Renunță",
                "styling-mode": "outlined",
                onClick: _ctx.onJurnalHide
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHiding"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isAddProductVisible,
      "show-title": true,
      width: 900,
      height: 680,
      "drag-enabled": true,
      "show-close-button": true,
      "close-on-outside-click": false,
      onHiding: _cache[60] || (_cache[60] = ($event: any) => (_ctx.isAddProductVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[81] || (_cache[81] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare Produs"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Completează datele produsului nou")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, "Nou")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _cache[91] || (_cache[91] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#3b82f6,#1d4ed8)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-key" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Identificare"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Date principale și clasificare")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _cache[82] || (_cache[82] = _createElementVNode("label", { class: "pfield-label" }, [
                      _createTextVNode("Cod Producător "),
                      _createElementVNode("span", { class: "field-req" }, "*")
                    ], -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.Cod,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newProductData.Cod) = $event)),
                      placeholder: "#AUTO"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _cache[83] || (_cache[83] = _createElementVNode("label", { class: "pfield-label" }, [
                      _createTextVNode("Denumire "),
                      _createElementVNode("span", { class: "field-req" }, "*")
                    ], -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.Nume,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newProductData.Nume) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[84] || (_cache[84] = _createElementVNode("label", { class: "pfield-label" }, "Categorie", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.CategorieId,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newProductData.CategorieId) = $event)),
                      "data-source": _ctx.dsCategorie,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true,
                      placeholder: "Selectează"
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _cache[85] || (_cache[85] = _createElementVNode("label", { class: "pfield-label" }, [
                      _createTextVNode("Unitate Măsură "),
                      _createElementVNode("span", { class: "field-req" }, "*")
                    ], -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.UnitateId,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newProductData.UnitateId) = $event)),
                      "data-source": _ctx.dsUnitati,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "search-enabled": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[86] || (_cache[86] = _createElementVNode("label", { class: "pfield-label" }, [
                      _createTextVNode("Categorie Contabilă "),
                      _createElementVNode("span", { class: "field-req" }, "*")
                    ], -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.CategorieContabilaId,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newProductData.CategorieContabilaId) = $event)),
                      "data-source": _ctx.dsCategorieContabila,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.Activ,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newProductData.Activ) = $event))
                    }, null, 8, ["value"]),
                    _cache[87] || (_cache[87] = _createElementVNode("span", null, "Activ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.Serviciu,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newProductData.Serviciu) = $event)),
                      onValueChanged: _ctx.onServiciuAddChanged
                    }, null, 8, ["value", "onValueChanged"]),
                    _cache[88] || (_cache[88] = _createElementVNode("span", null, "Serviciu", -1))
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.Stocabil,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newProductData.Stocabil) = $event))
                    }, null, 8, ["value"]),
                    _cache[89] || (_cache[89] = _createElementVNode("span", null, "Stocabil", -1))
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.SeCantareste,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newProductData.SeCantareste) = $event))
                    }, null, 8, ["value"]),
                    _cache[90] || (_cache[90] = _createElementVNode("span", null, "Se Cântărește", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _cache[101] || (_cache[101] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#10b981,#059669)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-money" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Prețuri & TVA"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Catalog, vânzare, taxe")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _cache[92] || (_cache[92] = _createElementVNode("label", { class: "pfield-label" }, "Preț Catalog", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.Pret,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newProductData.Pret) = $event)),
                      format: "#,##0.00####",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _cache[93] || (_cache[93] = _createElementVNode("label", { class: "pfield-label" }, "Preț Vânzare", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.PretVanzare,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newProductData.PretVanzare) = $event)),
                      format: "#,##0.00####",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _cache[94] || (_cache[94] = _createElementVNode("label", { class: "pfield-label" }, "Monedă", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.PretValutaId,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newProductData.PretValutaId) = $event)),
                      "data-source": _ctx.dsPretValuta,
                      "value-expr": "Id",
                      "display-expr": "Simbol",
                      "search-enabled": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _cache[95] || (_cache[95] = _createElementVNode("label", { class: "pfield-label" }, "Curs Bancă", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.PretCursBancaId,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newProductData.PretCursBancaId) = $event)),
                      "data-source": _ctx.dsBanci,
                      "value-expr": "ID",
                      "display-expr": "Cod",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _cache[96] || (_cache[96] = _createElementVNode("label", { class: "pfield-label" }, "TVA Curent (%)", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.TvaCurent,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newProductData.TvaCurent) = $event)),
                      format: "#,##0.##",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _cache[97] || (_cache[97] = _createElementVNode("label", { class: "pfield-label" }, "Data TVA", -1)),
                    _createVNode(_component_DxDateBox, {
                      value: _ctx.newProductData.TvaCurentData,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newProductData.TvaCurentData) = $event)),
                      "display-format": "dd.MM.yyyy",
                      type: "date"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _cache[98] || (_cache[98] = _createElementVNode("label", { class: "pfield-label" }, "Taxa Timbru Verde", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.TaxaVamala,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newProductData.TaxaVamala) = $event)),
                      format: "#,##0.00####",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _cache[99] || (_cache[99] = _createElementVNode("label", { class: "pfield-label" }, "Garanție (luni)", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.GarantieLuni,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newProductData.GarantieLuni) = $event)),
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.TaxareInversa,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.newProductData.TaxareInversa) = $event))
                    }, null, 8, ["value"]),
                    _cache[100] || (_cache[100] = _createElementVNode("span", null, "Taxare Inversă", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _cache[111] || (_cache[111] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#f59e0b,#d97706)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-product" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Stoc & Depozit"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Parametri gestiune și ambalare")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _cache[102] || (_cache[102] = _createElementVNode("label", { class: "pfield-label" }, "UM Ambalaj", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.UnitateAmbalajId,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newProductData.UnitateAmbalajId) = $event)),
                      "data-source": _ctx.dsUnitati,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _cache[103] || (_cache[103] = _createElementVNode("label", { class: "pfield-label" }, "Cantitate pt. 1 FA", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.CantitatePt1Fa,
                      "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.newProductData.CantitatePt1Fa) = $event)),
                      format: "#,##0.###",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _cache[104] || (_cache[104] = _createElementVNode("label", { class: "pfield-label" }, "Masă Bucată (g)", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.MasaBuc,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.newProductData.MasaBuc) = $event)),
                      format: "#,##0.00######",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _cache[105] || (_cache[105] = _createElementVNode("label", { class: "pfield-label" }, "Masă Net (g)", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.MasaBucNet,
                      "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newProductData.MasaBucNet) = $event)),
                      format: "#,##0.00######",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _cache[106] || (_cache[106] = _createElementVNode("label", { class: "pfield-label" }, "Q Avertizare Stoc", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.QavertizareStoc,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newProductData.QavertizareStoc) = $event)),
                      format: "#,##0.###",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _cache[107] || (_cache[107] = _createElementVNode("label", { class: "pfield-label" }, "Q Aprovizionare", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.newProductData.Qaprovizionare,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newProductData.Qaprovizionare) = $event)),
                      format: "#,##0.###",
                      "show-spin-buttons": true,
                      min: 0
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "pfield-label" }, "Loc Depozitare", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.LocDepozitare,
                      "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newProductData.LocDepozitare) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "pfield-label" }, "Tip Etichetă", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.TipEtichetaId,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newProductData.TipEtichetaId) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _cache[110] || (_cache[110] = _createElementVNode("label", { class: "pfield-label" }, "Sursă Produs", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.SursaProdus,
                      "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.newProductData.SursaProdus) = $event)),
                      "data-source": _ctx.dsSursaProdus,
                      "value-expr": "id",
                      "display-expr": "text",
                      "show-clear-button": true,
                      placeholder: "Selectați sursa"
                    }, null, 8, ["value", "data-source"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _cache[117] || (_cache[117] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#8b5cf6,#6d28d9)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-orderedlist" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Clasificare"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Coduri contabile și clasificații")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _cache[112] || (_cache[112] = _createElementVNode("label", { class: "pfield-label" }, "Clasificație Economică", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.ClasificatieEconomicaId,
                      "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.newProductData.ClasificatieEconomicaId) = $event)),
                      "data-source": _ctx.dsClasificatieEconomica,
                      "value-expr": "ID",
                      "display-expr": "Cod",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _cache[113] || (_cache[113] = _createElementVNode("label", { class: "pfield-label" }, "Cod D394", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.CodD394,
                      "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.newProductData.CodD394) = $event)),
                      "data-source": _ctx.dsCoduriD394,
                      "value-expr": "Nume",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "pfield-label" }, "Categorie TVA", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CategTva,
                      "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.newProductData.CategTva) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _cache[115] || (_cache[115] = _createElementVNode("label", { class: "pfield-label" }, "Motiv Scutire TVA", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CategTvaMotivScutire,
                      "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.newProductData.CategTvaMotivScutire) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _cache[116] || (_cache[116] = _createElementVNode("label", { class: "pfield-label" }, "Cod CPV", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodCPV,
                      "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.newProductData.CodCPV) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _cache[128] || (_cache[128] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#ec4899,#db2777)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-photo" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Prezentare"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Producător, coduri, imagine")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _cache[118] || (_cache[118] = _createElementVNode("label", { class: "pfield-label" }, "Producător", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.Producator,
                      "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.newProductData.Producator) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _cache[119] || (_cache[119] = _createElementVNode("label", { class: "pfield-label" }, "Țara Producătorului", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.ProducatorTaraId,
                      "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.newProductData.ProducatorTaraId) = $event)),
                      "data-source": _ctx.dsTari,
                      "value-expr": "ID",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _cache[120] || (_cache[120] = _createElementVNode("label", { class: "pfield-label" }, "Cod NC8", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodNc8id,
                      "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.newProductData.CodNc8id) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _cache[121] || (_cache[121] = _createElementVNode("label", { class: "pfield-label" }, "Cod Bare (Producător)", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodBare,
                      "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.newProductData.CodBare) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _cache[122] || (_cache[122] = _createElementVNode("label", { class: "pfield-label" }, "Marker", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.Marker,
                      "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.newProductData.Marker) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _cache[123] || (_cache[123] = _createElementVNode("label", { class: "pfield-label" }, "URL", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.Url,
                      "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.newProductData.Url) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _cache[127] || (_cache[127] = _createElementVNode("label", {
                    class: "pfield-label",
                    style: {"display":"block","margin-bottom":"8px"}
                  }, "Imagine produs", -1)),
                  _createElementVNode("div", _hoisted_105, [
                    (_ctx.newProductData.Imagine)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                          _createElementVNode("img", {
                            src: `data:image/jpeg;base64,${_ctx.newProductData.Imagine}`,
                            alt: "Imagine produs"
                          }, null, 8, _hoisted_107)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_108, [...(_cache[124] || (_cache[124] = [
                          _createElementVNode("i", { class: "dx-icon dx-icon-photo" }, null, -1),
                          _createElementVNode("span", null, "Fără imagine", -1)
                        ]))])),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("label", _hoisted_110, [
                        _cache[125] || (_cache[125] = _createElementVNode("i", { class: "dx-icon dx-icon-upload" }, null, -1)),
                        _cache[126] || (_cache[126] = _createTextVNode(" Încarcă ", -1)),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          onChange: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.onAddImageChange && _ctx.onAddImageChange(...args)))
                        }, null, 32)
                      ]),
                      (_ctx.newProductData.Imagine)
                        ? (_openBlock(), _createBlock(_component_DxButton, {
                            key: 0,
                            text: "Șterge",
                            type: "danger",
                            "styling-mode": "outlined",
                            height: 30,
                            onClick: _cache[50] || (_cache[50] = () => { _ctx.newProductData.Imagine = null; })
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _cache[137] || (_cache[137] = _createElementVNode("div", { class: "pcard-header" }, [
                _createElementVNode("div", {
                  class: "pcard-icon",
                  style: {"background":"linear-gradient(135deg,#14b8a6,#0d9488)"}
                }, [
                  _createElementVNode("i", { class: "dx-icon dx-icon-globe" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "pcard-title" }, "Marketplace & Web"),
                  _createElementVNode("div", { class: "pcard-subtitle" }, "Coduri marketplace, SGR și publicare")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _cache[129] || (_cache[129] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodPnk,
                      "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.newProductData.CodPnk) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _cache[130] || (_cache[130] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK BG", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodPNKBG,
                      "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.newProductData.CodPNKBG) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _cache[131] || (_cache[131] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK HU", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.CodPNKHU,
                      "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.newProductData.CodPNKHU) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _cache[132] || (_cache[132] = _createElementVNode("label", { class: "pfield-label" }, "Produs SGR", -1)),
                    _createVNode(_component_DxSelectBox, {
                      value: _ctx.newProductData.ProdusSgrID,
                      "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.newProductData.ProdusSgrID) = $event)),
                      "data-source": _ctx.dsProduse,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["value", "data-source"])
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _cache[133] || (_cache[133] = _createElementVNode("label", { class: "pfield-label" }, "Nume Comercial", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.newProductData.NumeComercial,
                      "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.newProductData.NumeComercial) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _cache[134] || (_cache[134] = _createElementVNode("label", { class: "pfield-label" }, "Descriere", -1)),
                    _createVNode(_component_DxTextArea, {
                      value: _ctx.newProductData.Descriere,
                      "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.newProductData.Descriere) = $event)),
                      height: 60
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.WwwListat,
                      "onUpdate:value": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.newProductData.WwwListat) = $event))
                    }, null, 8, ["value"]),
                    _cache[135] || (_cache[135] = _createElementVNode("span", null, "WWW Listat", -1))
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createVNode(_component_DxSwitch, {
                      value: _ctx.newProductData.WwwVizibil,
                      "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.newProductData.WwwVizibil) = $event))
                    }, null, 8, ["value"]),
                    _cache[136] || (_cache[136] = _createElementVNode("span", null, "WWW Vizibil", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_123, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              "styling-mode": "contained",
              icon: "check",
              onClick: _ctx.saveNewProduct
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Renunță",
              "styling-mode": "outlined",
              onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.isAddProductVisible = false))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openProducts, (item, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [
        (_ctx.selectedTabIndex === i + 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _cache[138] || (_cache[138] = _createElementVNode("div", { class: "produs-header-icon" }, [
                    _createElementVNode("i", { class: "dx-icon dx-icon-box" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_127, _toDisplayString(item.editData.Nume || 'Produs'), 1),
                    _createElementVNode("div", _hoisted_128, [
                      (item.editData.Cod)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_129, _toDisplayString(item.editData.Cod), 1))
                        : _createCommentVNode("", true),
                      (item.editData.CodIntern)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(item.editData.CodIntern), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(['pchip', item.editData.Activ ? 'pchip-activ' : 'pchip-inactiv'])
                      }, _toDisplayString(item.editData.Activ ? 'Activ' : 'Inactiv'), 3),
                      (item.editData.Serviciu)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_131, "Serviciu"))
                        : (item.editData.Stocabil)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_132, "Stocabil"))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_133, [
                  (item.isEditing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_DxButton, {
                          text: "Salvează",
                          "styling-mode": "outlined",
                          icon: "save",
                          class: "header-btn-save",
                          onClick: ($event: any) => (_ctx.saveProduct(i))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_DxButton, {
                          text: "Anulează",
                          "styling-mode": "outlined",
                          icon: "close",
                          class: "header-btn-cancel",
                          onClick: ($event: any) => (_ctx.cancelEdit(i))
                        }, null, 8, ["onClick"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("div", _hoisted_136, [
                    _cache[149] || (_cache[149] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#3b82f6,#1d4ed8);\" data-v-62655a27><i class=\"dx-icon dx-icon-key\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Identificare</div><div class=\"pcard-subtitle\" data-v-62655a27>Coduri și denumire principală</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("div", _hoisted_139, [
                          _cache[139] || (_cache[139] = _createElementVNode("label", { class: "pfield-label" }, "Cod Producător", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Cod,
                            "onUpdate:value": ($event: any) => ((item.editData.Cod) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _cache[140] || (_cache[140] = _createElementVNode("label", { class: "pfield-label" }, "Cod Intern", -1)),
                          _createVNode(_component_DxTextBox, {
                            value: item.editData.CodIntern,
                            "read-only": true,
                            placeholder: "#AUTO"
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _cache[141] || (_cache[141] = _createElementVNode("label", { class: "pfield-label" }, "Denumire *", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Nume,
                            "onUpdate:value": ($event: any) => ((item.editData.Nume) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_142, [
                          _cache[142] || (_cache[142] = _createElementVNode("label", { class: "pfield-label" }, "Categorie", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CategorieId,
                            "onUpdate:value": ($event: any) => ((item.editData.CategorieId) = $event),
                            "data-source": _ctx.dsCategorie,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_143, [
                          _cache[143] || (_cache[143] = _createElementVNode("label", { class: "pfield-label" }, "Unitate Măsură", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.UnitateId,
                            "onUpdate:value": ($event: any) => ((item.editData.UnitateId) = $event),
                            "data-source": _ctx.dsUnitati,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_144, [
                          _cache[144] || (_cache[144] = _createElementVNode("label", { class: "pfield-label" }, "Tip Etichetă", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.TipEtichetaId,
                            "onUpdate:value": ($event: any) => ((item.editData.TipEtichetaId) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_145, [
                        _createElementVNode("div", _hoisted_146, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.Activ,
                            "onUpdate:value": ($event: any) => ((item.editData.Activ) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[145] || (_cache[145] = _createElementVNode("span", null, "Activ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_147, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.Serviciu,
                            "onUpdate:value": ($event: any) => ((item.editData.Serviciu) = $event),
                            onValueChanged: (e) => _ctx.onServiciuChanged(e, item)
                          }, null, 8, ["read-only", "value", "onUpdate:value", "onValueChanged"]),
                          _cache[146] || (_cache[146] = _createElementVNode("span", null, "Serviciu", -1))
                        ]),
                        _createElementVNode("div", _hoisted_148, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.Stocabil,
                            "onUpdate:value": ($event: any) => ((item.editData.Stocabil) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[147] || (_cache[147] = _createElementVNode("span", null, "Stocabil", -1))
                        ]),
                        _createElementVNode("div", _hoisted_149, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.SeCantareste,
                            "onUpdate:value": ($event: any) => ((item.editData.SeCantareste) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[148] || (_cache[148] = _createElementVNode("span", null, "Se Cântărește", -1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _cache[164] || (_cache[164] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#10b981,#059669);\" data-v-62655a27><i class=\"dx-icon dx-icon-money\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Prețuri &amp; TVA</div><div class=\"pcard-subtitle\" data-v-62655a27>Prețuri de catalog și taxe</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_151, [
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("div", _hoisted_153, [
                          _cache[150] || (_cache[150] = _createElementVNode("label", { class: "pfield-label" }, "Preț Catalog", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Pret,
                            "onUpdate:value": ($event: any) => ((item.editData.Pret) = $event),
                            format: "#,##0.00####",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_154, [
                          _cache[151] || (_cache[151] = _createElementVNode("label", { class: "pfield-label" }, "Preț Vânzare", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.PretVanzare,
                            "onUpdate:value": ($event: any) => ((item.editData.PretVanzare) = $event),
                            format: "#,##0.00####",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_155, [
                          _cache[152] || (_cache[152] = _createElementVNode("label", { class: "pfield-label" }, "Preț Vânzare Anterior", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.PretVanzareAnterior,
                            "onUpdate:value": ($event: any) => ((item.editData.PretVanzareAnterior) = $event),
                            format: "#,##0.00####",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_156, [
                          _cache[153] || (_cache[153] = _createElementVNode("label", { class: "pfield-label" }, "Preț Vânzare Dată", -1)),
                          _createVNode(_component_DxDateBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.PretVanzareData,
                            "onUpdate:value": ($event: any) => ((item.editData.PretVanzareData) = $event),
                            "display-format": "dd.MM.yyyy",
                            type: "date"
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_157, [
                          _cache[154] || (_cache[154] = _createElementVNode("label", { class: "pfield-label" }, "Monedă", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.PretValutaId,
                            "onUpdate:value": ($event: any) => ((item.editData.PretValutaId) = $event),
                            "data-source": _ctx.dsPretValuta,
                            "value-expr": "Id",
                            "display-expr": "Simbol",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_158, [
                          _cache[155] || (_cache[155] = _createElementVNode("label", { class: "pfield-label" }, "Curs Bancă", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.PretCursBancaId,
                            "onUpdate:value": ($event: any) => ((item.editData.PretCursBancaId) = $event),
                            "data-source": _ctx.dsBanci,
                            "value-expr": "ID",
                            "display-expr": "Cod",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_159, [
                          _cache[156] || (_cache[156] = _createElementVNode("label", { class: "pfield-label" }, "TVA Curent (%)", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.TvaCurent,
                            "onUpdate:value": ($event: any) => ((item.editData.TvaCurent) = $event),
                            format: "#,##0.##",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_160, [
                          _cache[157] || (_cache[157] = _createElementVNode("label", { class: "pfield-label" }, "Data TVA", -1)),
                          _createVNode(_component_DxDateBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.TvaCurentData,
                            "onUpdate:value": ($event: any) => ((item.editData.TvaCurentData) = $event),
                            "display-format": "dd/MM/yyyy",
                            type: "date"
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _cache[158] || (_cache[158] = _createElementVNode("label", { class: "pfield-label" }, "TVA Anterior (%)", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.TvaAnterior,
                            "onUpdate:value": ($event: any) => ((item.editData.TvaAnterior) = $event),
                            format: "#,##0.##",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_162, [
                          _cache[159] || (_cache[159] = _createElementVNode("label", { class: "pfield-label" }, "Taxă Timbru Verde", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.TaxaVamala,
                            "onUpdate:value": ($event: any) => ((item.editData.TaxaVamala) = $event),
                            format: "#,##0.00####",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_163, [
                          _cache[160] || (_cache[160] = _createElementVNode("label", { class: "pfield-label" }, "Garantie (luni)", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.GarantieLuni,
                            "onUpdate:value": ($event: any) => ((item.editData.GarantieLuni) = $event),
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_164, [
                          _cache[161] || (_cache[161] = _createElementVNode("label", { class: "pfield-label" }, "Categorie TVA", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CategTva,
                            "onUpdate:value": ($event: any) => ((item.editData.CategTva) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_165, [
                          _cache[162] || (_cache[162] = _createElementVNode("label", { class: "pfield-label" }, "Motiv Scutire TVA", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CategTvaMotivScutire,
                            "onUpdate:value": ($event: any) => ((item.editData.CategTvaMotivScutire) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", _hoisted_167, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.TaxareInversa,
                            "onUpdate:value": ($event: any) => ((item.editData.TaxareInversa) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[163] || (_cache[163] = _createElementVNode("span", null, "Taxare Inversă", -1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _cache[168] || (_cache[168] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#8b5cf6,#6d28d9);\" data-v-62655a27><i class=\"dx-icon dx-icon-orderedlist\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Clasificare Contabilă</div><div class=\"pcard-subtitle\" data-v-62655a27>Categorii și coduri contabile</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _cache[165] || (_cache[165] = _createElementVNode("label", { class: "pfield-label" }, "Clasificație Economică", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.ClasificatieEconomicaId,
                            "onUpdate:value": ($event: any) => ((item.editData.ClasificatieEconomicaId) = $event),
                            "data-source": _ctx.dsClasificatieEconomica,
                            "value-expr": "ID",
                            "display-expr": "Cod",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_172, [
                          _cache[166] || (_cache[166] = _createElementVNode("label", { class: "pfield-label" }, "Cod D394", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodD394,
                            "onUpdate:value": ($event: any) => ((item.editData.CodD394) = $event),
                            "data-source": _ctx.dsCoduriD394,
                            "value-expr": "Nume",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_173, [
                          _cache[167] || (_cache[167] = _createElementVNode("label", { class: "pfield-label" }, "Cod CPV", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodCPV,
                            "onUpdate:value": ($event: any) => ((item.editData.CodCPV) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _cache[183] || (_cache[183] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#ec4899,#db2777);\" data-v-62655a27><i class=\"dx-icon dx-icon-photo\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Prezentare &amp; Media</div><div class=\"pcard-subtitle\" data-v-62655a27>Producător, coduri, imagine</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("div", _hoisted_176, [
                        _createElementVNode("div", _hoisted_177, [
                          _cache[169] || (_cache[169] = _createElementVNode("label", { class: "pfield-label" }, "Producător", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Producator,
                            "onUpdate:value": ($event: any) => ((item.editData.Producator) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_178, [
                          _cache[170] || (_cache[170] = _createElementVNode("label", { class: "pfield-label" }, "Țara Producătorului", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.ProducatorTaraId,
                            "onUpdate:value": ($event: any) => ((item.editData.ProducatorTaraId) = $event),
                            "data-source": _ctx.dsTari,
                            "value-expr": "ID",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_179, [
                          _cache[171] || (_cache[171] = _createElementVNode("label", { class: "pfield-label" }, "Cod NC8", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodNc8id,
                            "onUpdate:value": ($event: any) => ((item.editData.CodNc8id) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_180, [
                          _cache[172] || (_cache[172] = _createElementVNode("label", { class: "pfield-label" }, "Cod Bare", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodBare,
                            "onUpdate:value": ($event: any) => ((item.editData.CodBare) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_181, [
                          _cache[173] || (_cache[173] = _createElementVNode("label", { class: "pfield-label" }, "Marker", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Marker,
                            "onUpdate:value": ($event: any) => ((item.editData.Marker) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_182, [
                          _cache[174] || (_cache[174] = _createElementVNode("label", { class: "pfield-label" }, "URL", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Url,
                            "onUpdate:value": ($event: any) => ((item.editData.Url) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_183, [
                          _cache[175] || (_cache[175] = _createElementVNode("label", { class: "pfield-label" }, "Denumire Comercială", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.NumeComercial,
                            "onUpdate:value": ($event: any) => ((item.editData.NumeComercial) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_184, [
                          _cache[176] || (_cache[176] = _createElementVNode("label", { class: "pfield-label" }, "Categorie Contabilă", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CategorieContabilaId,
                            "onUpdate:value": ($event: any) => ((item.editData.CategorieContabilaId) = $event),
                            "data-source": _ctx.dsCategorieContabila,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_185, [
                          _cache[177] || (_cache[177] = _createElementVNode("label", { class: "pfield-label" }, "Descriere", -1)),
                          _createVNode(_component_DxTextArea, {
                            "read-only": !item.isEditing,
                            value: item.editData.Descriere,
                            "onUpdate:value": ($event: any) => ((item.editData.Descriere) = $event),
                            height: 70
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_186, [
                          _cache[178] || (_cache[178] = _createElementVNode("label", { class: "pfield-label" }, "Compatibilitate", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Compatibilitate,
                            "onUpdate:value": ($event: any) => ((item.editData.Compatibilitate) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_187, [
                        _cache[182] || (_cache[182] = _createElementVNode("label", { class: "pfield-label" }, "Imagine produs", -1)),
                        _createElementVNode("div", _hoisted_188, [
                          (item.editData.Imagine)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                _createElementVNode("img", {
                                  src: `data:image/jpeg;base64,${item.editData.Imagine}`,
                                  alt: "Imagine produs"
                                }, null, 8, _hoisted_190)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_191, [...(_cache[179] || (_cache[179] = [
                                _createElementVNode("i", { class: "dx-icon dx-icon-photo" }, null, -1),
                                _createElementVNode("span", null, "Nicio imagine", -1)
                              ]))])),
                          (item.isEditing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                                _createElementVNode("label", _hoisted_193, [
                                  _cache[180] || (_cache[180] = _createElementVNode("i", { class: "dx-icon dx-icon-upload" }, null, -1)),
                                  _cache[181] || (_cache[181] = _createTextVNode(" Încarcă imagine ", -1)),
                                  _createElementVNode("input", {
                                    type: "file",
                                    accept: "image/*",
                                    onChange: ($event: any) => (_ctx.onImageChange($event, item))
                                  }, null, 40, _hoisted_194)
                                ]),
                                (item.editData.Imagine)
                                  ? (_openBlock(), _createBlock(_component_DxButton, {
                                      key: 0,
                                      text: "Șterge",
                                      type: "danger",
                                      "styling-mode": "outlined",
                                      onClick: () => { item.editData.Imagine = null; item.imagineChanged = true; }
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_195, [
                    _cache[192] || (_cache[192] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#f59e0b,#d97706);\" data-v-62655a27><i class=\"dx-icon dx-icon-product\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Stoc &amp; Depozit</div><div class=\"pcard-subtitle\" data-v-62655a27>Gestiune și parametri stoc</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_196, [
                      _createElementVNode("div", _hoisted_197, [
                        _createElementVNode("div", _hoisted_198, [
                          _cache[184] || (_cache[184] = _createElementVNode("label", { class: "pfield-label" }, "UM Ambalaj", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.UnitateAmbalajId,
                            "onUpdate:value": ($event: any) => ((item.editData.UnitateAmbalajId) = $event),
                            "data-source": _ctx.dsUnitati,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_199, [
                          _cache[185] || (_cache[185] = _createElementVNode("label", { class: "pfield-label" }, "Cantitate pt. 1 FA", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CantitatePt1Fa,
                            "onUpdate:value": ($event: any) => ((item.editData.CantitatePt1Fa) = $event),
                            format: "#,##0.###",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_200, [
                          _cache[186] || (_cache[186] = _createElementVNode("label", { class: "pfield-label" }, "Q Avertizare Stoc", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.QavertizareStoc,
                            "onUpdate:value": ($event: any) => ((item.editData.QavertizareStoc) = $event),
                            format: "#,##0.###",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_201, [
                          _cache[187] || (_cache[187] = _createElementVNode("label", { class: "pfield-label" }, "Q Aprovizionare", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.Qaprovizionare,
                            "onUpdate:value": ($event: any) => ((item.editData.Qaprovizionare) = $event),
                            format: "#,##0.###",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_202, [
                          _cache[188] || (_cache[188] = _createElementVNode("label", { class: "pfield-label" }, "Loc Depozitare", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.LocDepozitare,
                            "onUpdate:value": ($event: any) => ((item.editData.LocDepozitare) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_203, [
                          _cache[189] || (_cache[189] = _createElementVNode("label", { class: "pfield-label" }, "Masă Bucată", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.MasaBuc,
                            "onUpdate:value": ($event: any) => ((item.editData.MasaBuc) = $event),
                            format: "#,##0.00######",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_204, [
                          _cache[190] || (_cache[190] = _createElementVNode("label", { class: "pfield-label" }, "Masă Net", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.MasaBucNet,
                            "onUpdate:value": ($event: any) => ((item.editData.MasaBucNet) = $event),
                            format: "#,##0.00######",
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_205, [
                          _cache[191] || (_cache[191] = _createElementVNode("label", { class: "pfield-label" }, "Sursă Produs", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.SursaProdus,
                            "onUpdate:value": ($event: any) => ((item.editData.SursaProdus) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_206, [
                    _cache[204] || (_cache[204] = _createStaticVNode("<div class=\"pcard-header\" data-v-62655a27><div class=\"pcard-icon\" style=\"background:linear-gradient(135deg,#14b8a6,#0d9488);\" data-v-62655a27><i class=\"dx-icon dx-icon-globe\" data-v-62655a27></i></div><div data-v-62655a27><div class=\"pcard-title\" data-v-62655a27>Marketplace &amp; Web</div><div class=\"pcard-subtitle\" data-v-62655a27>Coduri marketplace și publicare web</div></div></div>", 1)),
                    _createElementVNode("div", _hoisted_207, [
                      _createElementVNode("div", _hoisted_208, [
                        _createElementVNode("div", _hoisted_209, [
                          _cache[193] || (_cache[193] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodPnk,
                            "onUpdate:value": ($event: any) => ((item.editData.CodPnk) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_210, [
                          _cache[194] || (_cache[194] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK BG", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodPNKBG,
                            "onUpdate:value": ($event: any) => ((item.editData.CodPNKBG) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_211, [
                          _cache[195] || (_cache[195] = _createElementVNode("label", { class: "pfield-label" }, "Cod PNK HU", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.CodPNKHU,
                            "onUpdate:value": ($event: any) => ((item.editData.CodPNKHU) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_212, [
                          _cache[196] || (_cache[196] = _createElementVNode("label", { class: "pfield-label" }, "eMAG ID", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.eMAGID,
                            "onUpdate:value": ($event: any) => ((item.editData.eMAGID) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_213, [
                          _cache[197] || (_cache[197] = _createElementVNode("label", { class: "pfield-label" }, "eMAG ID BG", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.eMAGIDBG,
                            "onUpdate:value": ($event: any) => ((item.editData.eMAGIDBG) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_214, [
                          _cache[198] || (_cache[198] = _createElementVNode("label", { class: "pfield-label" }, "eMAG ID HU", -1)),
                          _createVNode(_component_DxTextBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.eMAGIDHU,
                            "onUpdate:value": ($event: any) => ((item.editData.eMAGIDHU) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_215, [
                          _cache[199] || (_cache[199] = _createElementVNode("label", { class: "pfield-label" }, "Produs SGR", -1)),
                          _createVNode(_component_DxSelectBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.ProdusSgrID,
                            "onUpdate:value": ($event: any) => ((item.editData.ProdusSgrID) = $event),
                            "data-source": _ctx.dsProduse,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "search-enabled": true,
                            "show-clear-button": true
                          }, null, 8, ["read-only", "value", "onUpdate:value", "data-source"])
                        ]),
                        _createElementVNode("div", _hoisted_216, [
                          _cache[200] || (_cache[200] = _createElementVNode("label", { class: "pfield-label" }, "Www ID", -1)),
                          _createVNode(_component_DxNumberBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.WwwID,
                            "onUpdate:value": ($event: any) => ((item.editData.WwwID) = $event),
                            "show-spin-buttons": true,
                            min: 0
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_217, [
                          _cache[201] || (_cache[201] = _createElementVNode("label", { class: "pfield-label" }, "Www Synced Date", -1)),
                          _createVNode(_component_DxDateBox, {
                            "read-only": !item.isEditing,
                            value: item.editData.WwwSyncedDate,
                            "onUpdate:value": ($event: any) => ((item.editData.WwwSyncedDate) = $event),
                            "display-format": "dd.MM.yyyy HH:mm",
                            type: "datetime"
                          }, null, 8, ["read-only", "value", "onUpdate:value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("div", _hoisted_219, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.WwwListat,
                            "onUpdate:value": ($event: any) => ((item.editData.WwwListat) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[202] || (_cache[202] = _createElementVNode("span", null, "Www Listat", -1))
                        ]),
                        _createElementVNode("div", _hoisted_220, [
                          _createVNode(_component_DxSwitch, {
                            "read-only": !item.isEditing,
                            value: item.editData.WwwVizibil,
                            "onUpdate:value": ($event: any) => ((item.editData.WwwVizibil) = $event)
                          }, null, 8, ["read-only", "value", "onUpdate:value"]),
                          _cache[203] || (_cache[203] = _createElementVNode("span", null, "Www Vizibil", -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (!item.isEditing)
                ? (_openBlock(), _createBlock(_component_DxSpeedDialAction, {
                    key: 0,
                    icon: "edit",
                    label: "Editează",
                    index: 1,
                    onClick: ($event: any) => (item.isEditing = true)
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}